import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const DashboardActions = {
    getLastData(params) {
        dispatch({
            type  : AppConstants.DASHBOARD_LAST_START_LOADING
        });

        return api.getReportByDay(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.DASHBOARD_LAST_SUCCESS,
                    items : data.response || {}
                });
                return data;
            })
            .catch(err => {
                console.warn('Dashboard getLastData API error:', err);
                dispatch({
                    type  : AppConstants.DASHBOARD_LAST_FAIL,
                    error : {
                        message: err.message || 'API Error',
                        status: err.status || 400,
                        type: 'API_ERROR'
                    }
                });
                throw err;
            });
    },

    getTodayData(params) {
        dispatch({
            type  : AppConstants.DASHBOARD_TODAY_START_LOADING
        });

        return api.getReportByDay(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.DASHBOARD_TODAY_SUCCESS,
                    items : data.response || {}
                });
                return data;
            })
            .catch(err => {
                console.warn('Dashboard getTodayData API error:', err);
                dispatch({
                    type  : AppConstants.DASHBOARD_TODAY_FAIL,
                    error : {
                        message: err.message || 'API Error',
                        status: err.status || 400,
                        type: 'API_ERROR'
                    }
                });
                throw err;
            });
    }
};

export default DashboardActions;
